import { gql } from '@apollo/client';
import { Int, String } from '../get-real-estates';
import { FriendPagination } from './friend-list';

export interface FriendRequestListData {
  friendRequestList?: FriendPagination;
}
export interface FriendRequestListVariables {
  page?: Int;
  limit?: Int;
  search?: String;
}
export const FRIEND_REQUEST_LIST = gql`
  query friendRequestList($page: Int, $limit: Int, $search: String) @api(name: social) {
    friendRequestList(page: $page, limit: $limit, search: $search) {
      data {
        _id
        requester
        recipient
        status
        friend {
          id
          fullName
          gender
          avatar {
            fileId
            originalUrl
          }
        }
        isBlockRequester
      }
      hasNextPage
      limit
      page
      prevPage
      total
      hasPrevPage
      nextPage
      pagingCounter
      totalPages
    }
  }
`;
